<template>
  <div class="c-info-row">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CInfoRow',
}
</script>

<style lang="scss">
.c-info-row {
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  width: 100%;
  min-width: 0;
  background-color: color-var(text, base-05);
  background-size: cover;
  background-position: center;
  border-radius: 5px;

  @include responsive(tablet, desktop) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    min-height: 60px;
    max-width: 100%;
  }
}
</style>
